import KibanaFilterModel from './osd-filter-model';
export default class IsBetweenFilterModel extends KibanaFilterModel {
    range;
    constructor(metadata) {
        super(metadata);
        if (!metadata.key)
            return;
        const [from, to] = metadata.value.split('to').map(item => Number(item));
        this.range = {
            [metadata.key]: {
                gte: isNaN(from) ? null : from,
                lt: isNaN(to) ? null : to,
            },
        };
    }
}
//# sourceMappingURL=is-between-filter-model.js.map